@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-718_335_625)
internal val Res.string.exp_content_e_guarda_la_seconda_parola_racchiusa_nel_cart: StringResource by
    lazy {
      StringResource("string:exp_content_e_guarda_la_seconda_parola_racchiusa_nel_cart", "exp_content_e_guarda_la_seconda_parola_racchiusa_nel_cart", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 37996, 257),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38096, 265),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39004, 269),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36692, 253),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35120, 261),
      ))
    }

@delegate:ResourceContentHash(-1_600_500_040)
internal val Res.string.exp_content_e_poi_all_interno_uhm_imn_twt_ankh: StringResource by lazy {
      StringResource("string:exp_content_e_poi_all_interno_uhm_imn_twt_ankh", "exp_content_e_poi_all_interno_uhm_imn_twt_ankh", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 38254, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38362, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39274, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36946, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35382, 118),
      ))
    }

@delegate:ResourceContentHash(1_861_257_430)
internal val Res.string.exp_content_ecco_fatto_1: StringResource by lazy {
      StringResource("string:exp_content_ecco_fatto_1", "exp_content_ecco_fatto_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 38381, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38485, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39397, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37057, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35501, 48),
      ))
    }

@delegate:ResourceContentHash(-2_107_522_921)
internal val Res.string.exp_content_ecco_fatto_2: StringResource by lazy {
      StringResource("string:exp_content_ecco_fatto_2", "exp_content_ecco_fatto_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 38430, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38538, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39446, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37106, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35550, 48),
      ))
    }

@delegate:ResourceContentHash(875_473_426)
internal val Res.string.exp_content_ecco_fatto_3: StringResource by lazy {
      StringResource("string:exp_content_ecco_fatto_3", "exp_content_ecco_fatto_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 38471, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38583, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39495, 120),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37147, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35599, 88),
      ))
    }

@delegate:ResourceContentHash(2_051_858_141)
internal val Res.string.exp_content_ecco_fatto_4: StringResource by lazy {
      StringResource("string:exp_content_ecco_fatto_4", "exp_content_ecco_fatto_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 38572, 112),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38664, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39616, 140),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37244, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35688, 96),
      ))
    }

@delegate:ResourceContentHash(-113_982_305)
internal val Res.string.exp_content_ecco_fatto_5: StringResource by lazy {
      StringResource("string:exp_content_ecco_fatto_5", "exp_content_ecco_fatto_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 38685, 148),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38789, 152),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39757, 164),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37357, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35785, 148),
      ))
    }

@delegate:ResourceContentHash(13_725_394)
internal val Res.string.exp_content_ecco_fatto_6: StringResource by lazy {
      StringResource("string:exp_content_ecco_fatto_6", "exp_content_ecco_fatto_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 38834, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38942, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39922, 80),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37490, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35934, 72),
      ))
    }

@delegate:ResourceContentHash(1_868_233_262)
internal val Res.string.exp_content_ecco_fatto_7: StringResource by lazy {
      StringResource("string:exp_content_ecco_fatto_7", "exp_content_ecco_fatto_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 38911, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39019, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40003, 124),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37567, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36007, 108),
      ))
    }

@delegate:ResourceContentHash(-551_438_946)
internal val Res.string.exp_content_ecco_fatto_8: StringResource by lazy {
      StringResource("string:exp_content_ecco_fatto_8", "exp_content_ecco_fatto_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 39028, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39136, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40128, 36),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37692, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36116, 36),
      ))
    }

@delegate:ResourceContentHash(-85_674_040)
internal val Res.string.exp_content_ecco_un_elenco_di_tre_elementi_n_falco_pesce_: StringResource by
    lazy {
      StringResource("string:exp_content_ecco_un_elenco_di_tre_elementi_n_falco_pesce_", "exp_content_ecco_un_elenco_di_tre_elementi_n_falco_pesce_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 39065, 153),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39173, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40165, 157),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37729, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36153, 137),
      ))
    }

@delegate:ResourceContentHash(-664_568_187)
internal val Res.string.exp_content_ecco_un_secondo_giro_di_simboli: StringResource by lazy {
      StringResource("string:exp_content_ecco_un_secondo_giro_di_simboli", "exp_content_ecco_un_secondo_giro_di_simboli", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 39219, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39319, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40323, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37871, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36291, 95),
      ))
    }

@delegate:ResourceContentHash(582_672_007)
internal val Res.string.exp_content_ecco_vari_modi_di_scrivere_le_due_sorelle_snt: StringResource by
    lazy {
      StringResource("string:exp_content_ecco_vari_modi_di_scrivere_le_due_sorelle_snt", "exp_content_ecco_vari_modi_di_scrivere_le_due_sorelle_snt", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 39319, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39427, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40427, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37967, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36387, 141),
      ))
    }

@delegate:ResourceContentHash(2_143_098_955)
internal val Res.string.exp_content_eccoci_al_tempio_di_bastet: StringResource by lazy {
      StringResource("string:exp_content_eccoci_al_tempio_di_bastet", "exp_content_eccoci_al_tempio_di_bastet", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 39485, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39577, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40581, 86),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 38101, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36529, 90),
      ))
    }

@delegate:ResourceContentHash(0)
internal val Res.string.exp_content_empty: StringResource by lazy {
      StringResource("string:exp_content_empty", "exp_content_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 39572, 25),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39672, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40668, 25),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 38184, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36620, 25),
      ))
    }

@delegate:ResourceContentHash(1_358_958)
internal val Res.string.exp_content_end_verb_1_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_end_verb_1_alyn_1", "exp_content_end_verb_1_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 39598, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39698, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40694, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 38210, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36646, 105),
      ))
    }

@delegate:ResourceContentHash(-453_259_093)
internal val Res.string.exp_content_end_verb_1_alyn_2: StringResource by lazy {
      StringResource("string:exp_content_end_verb_1_alyn_2", "exp_content_end_verb_1_alyn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 39728, 137),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39824, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40820, 145),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 38328, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36752, 121),
      ))
    }

@delegate:ResourceContentHash(-1_848_626_712)
internal val Res.string.exp_content_end_verb_1_alyn_3: StringResource by lazy {
      StringResource("string:exp_content_end_verb_1_alyn_3", "exp_content_end_verb_1_alyn_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 39866, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39954, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40966, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 38454, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36874, 121),
      ))
    }

@delegate:ResourceContentHash(-751_328_929)
internal val Res.string.exp_content_end_verb_1_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_end_verb_1_nilo_1", "exp_content_end_verb_1_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 39996, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40084, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41100, 97),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 38580, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36996, 89),
      ))
    }

@delegate:ResourceContentHash(877_995_374)
internal val Res.string.exp_content_end_verb_1_zeta_1: StringResource by lazy {
      StringResource("string:exp_content_end_verb_1_zeta_1", "exp_content_end_verb_1_zeta_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 40094, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40182, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41198, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 38662, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37086, 137),
      ))
    }

@delegate:ResourceContentHash(1_065_207_336)
internal val Res.string.exp_content_end_verb_1_zeta_2: StringResource by lazy {
      StringResource("string:exp_content_end_verb_1_zeta_2", "exp_content_end_verb_1_zeta_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 40228, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40328, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41336, 141),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 38804, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37224, 125),
      ))
    }

@delegate:ResourceContentHash(1_267_965_158)
internal val Res.string.exp_content_end_verb_1_zeta_3: StringResource by lazy {
      StringResource("string:exp_content_end_verb_1_zeta_3", "exp_content_end_verb_1_zeta_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 40386, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40458, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41478, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 38950, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37350, 113),
      ))
    }

@delegate:ResourceContentHash(-1_259_680_241)
internal val Res.string.exp_content_end_verb_1_zeta_4: StringResource by lazy {
      StringResource("string:exp_content_end_verb_1_zeta_4", "exp_content_end_verb_1_zeta_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 40528, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40584, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41616, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 39076, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37464, 133),
      ))
    }

@delegate:ResourceContentHash(1_958_884_967)
internal val Res.string.exp_content_end_verb_1_zeta_5: StringResource by lazy {
      StringResource("string:exp_content_end_verb_1_zeta_5", "exp_content_end_verb_1_zeta_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 40670, 105),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40706, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41754, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 39206, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37598, 109),
      ))
    }

@delegate:ResourceContentHash(2_023_859_634)
internal val Res.string.exp_content_ending_vso_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_ending_vso_alyn_1", "exp_content_ending_vso_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 40776, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40828, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41888, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 39324, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37708, 81),
      ))
    }

@delegate:ResourceContentHash(-2_029_803_942)
internal val Res.string.exp_content_ending_vso_alyn_2: StringResource by lazy {
      StringResource("string:exp_content_ending_vso_alyn_2", "exp_content_ending_vso_alyn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 40854, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40906, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41982, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 39410, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37790, 77),
      ))
    }

@delegate:ResourceContentHash(-752_599_356)
internal val Res.string.exp_content_ending_vso_alyn_3: StringResource by lazy {
      StringResource("string:exp_content_ending_vso_alyn_3", "exp_content_ending_vso_alyn_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 40936, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40984, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42076, 129),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 39492, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37868, 101),
      ))
    }

@delegate:ResourceContentHash(-262_181_006)
internal val Res.string.exp_content_ending_vso_masko_1: StringResource by lazy {
      StringResource("string:exp_content_ending_vso_masko_1", "exp_content_ending_vso_masko_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 41054, 114),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41114, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42206, 102),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 39606, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37970, 98),
      ))
    }

@delegate:ResourceContentHash(1_529_547_567)
internal val Res.string.exp_content_ending_vso_masko_2: StringResource by lazy {
      StringResource("string:exp_content_ending_vso_masko_2", "exp_content_ending_vso_masko_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 41169, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41221, 150),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42309, 138),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 39705, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38069, 130),
      ))
    }

@delegate:ResourceContentHash(586_799_176)
internal val Res.string.exp_content_ending_vso_masko_3: StringResource by lazy {
      StringResource("string:exp_content_ending_vso_masko_3", "exp_content_ending_vso_masko_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 41296, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41372, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42448, 126),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 39852, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38200, 102),
      ))
    }

@delegate:ResourceContentHash(1_379_329_080)
internal val Res.string.exp_content_ending_vso_masko_4: StringResource by lazy {
      StringResource("string:exp_content_ending_vso_masko_4", "exp_content_ending_vso_masko_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 41419, 82),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41495, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42575, 78),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 39967, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38303, 82),
      ))
    }

@delegate:ResourceContentHash(505_367_805)
internal val Res.string.exp_content_ending_vso_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_ending_vso_nilo_1", "exp_content_ending_vso_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 41502, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41582, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42654, 97),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 40050, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38386, 85),
      ))
    }

@delegate:ResourceContentHash(-905_388_690)
internal val Res.string.exp_content_esempi: StringResource by lazy {
      StringResource("string:exp_content_esempi", "exp_content_esempi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 42731, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42763, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43863, 38),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 41167, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39511, 38),
      ))
    }

@delegate:ResourceContentHash(-1_264_893_760)
internal val Res.string.exp_content_esempio_genitivo_indiretto_femminile_plurale: StringResource by
    lazy {
      StringResource("string:exp_content_esempio_genitivo_indiretto_femminile_plurale", "exp_content_esempio_genitivo_indiretto_femminile_plurale", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 41596, 276),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41684, 260),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42752, 260),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 40136, 240),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38472, 240),
      ))
    }

@delegate:ResourceContentHash(869_917_939)
internal val Res.string.exp_content_esempio_genitivo_indiretto_femminile_singolare: StringResource
    by lazy {
      StringResource("string:exp_content_esempio_genitivo_indiretto_femminile_singolare", "exp_content_esempio_genitivo_indiretto_femminile_singolare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 41873, 222),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41945, 190),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43013, 202),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 40377, 194),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38713, 190),
      ))
    }

@delegate:ResourceContentHash(613_363_837)
internal val Res.string.exp_content_esempio_genitivo_indiretto_maschile_plurale: StringResource by
    lazy {
      StringResource("string:exp_content_esempio_genitivo_indiretto_maschile_plurale", "exp_content_esempio_genitivo_indiretto_maschile_plurale", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 42096, 191),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42136, 187),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43216, 187),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 40572, 179),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38904, 183),
      ))
    }

@delegate:ResourceContentHash(354_448_708)
internal val Res.string.exp_content_esempio_genitivo_indiretto_maschile_singolare: StringResource by
    lazy {
      StringResource("string:exp_content_esempio_genitivo_indiretto_maschile_singolare", "exp_content_esempio_genitivo_indiretto_maschile_singolare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 42288, 189),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42324, 181),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43404, 189),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 40752, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39088, 173),
      ))
    }

@delegate:ResourceContentHash(949_442_294)
internal val Res.string.exp_content_esempio_padre_any_n_nil_padre_any_n_s_n_un: StringResource by
    lazy {
      StringResource("string:exp_content_esempio_padre_any_n_nil_padre_any_n_s_n_un", "exp_content_esempio_padre_any_n_nil_padre_any_n_s_n_un", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 42478, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42506, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43594, 114),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 40926, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39262, 106),
      ))
    }

@delegate:ResourceContentHash(49_401_576)
internal val Res.string.exp_content_esempio_sacerdote_ptah_n_nil_sacerdote_ptah_n: StringResource by
    lazy {
      StringResource("string:exp_content_esempio_sacerdote_ptah_n_nil_sacerdote_ptah_n", "exp_content_esempio_sacerdote_ptah_n_nil_sacerdote_ptah_n", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 42589, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42613, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43709, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 41029, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39369, 141),
      ))
    }

@delegate:ResourceContentHash(-226_760_552)
internal val Res.string.exp_content_esiste_poi_anche_il_plurale_duale_che_si_fa_a: StringResource by
    lazy {
      StringResource("string:exp_content_esiste_poi_anche_il_plurale_duale_che_si_fa_a", "exp_content_esiste_poi_anche_il_plurale_duale_che_si_fa_a", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 42770, 237),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42802, 201),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43902, 193),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 41202, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39550, 205),
      ))
    }

@delegate:ResourceContentHash(1_831_398_912)
internal val Res.string.exp_content_esistono_diversi_tipi_di_segni_n_n_fonogrammi: StringResource by
    lazy {
      StringResource("string:exp_content_esistono_diversi_tipi_di_segni_n_n_fonogrammi", "exp_content_esistono_diversi_tipi_di_segni_n_n_fonogrammi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 43008, 185),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43004, 181),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44096, 189),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 41404, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39756, 177),
      ))
    }

@delegate:ResourceContentHash(244_081_388)
internal val Res.string.exp_content_esploriamo_l_ambiente_e_il_mondo_egizio: StringResource by
    lazy {
      StringResource("string:exp_content_esploriamo_l_ambiente_e_il_mondo_egizio", "exp_content_esploriamo_l_ambiente_e_il_mondo_egizio", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 43194, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43186, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44286, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 41578, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39934, 127),
      ))
    }

@delegate:ResourceContentHash(798_148_126)
internal val Res.string.exp_content_facciamo_il_punto_1: StringResource by lazy {
      StringResource("string:exp_content_facciamo_il_punto_1", "exp_content_facciamo_il_punto_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 43451, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43427, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44539, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 41803, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40171, 75),
      ))
    }

@delegate:ResourceContentHash(220_093_656)
internal val Res.string.exp_content_facciamo_il_punto_10: StringResource by lazy {
      StringResource("string:exp_content_facciamo_il_punto_10", "exp_content_facciamo_il_punto_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 43318, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43302, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44410, 128),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 41694, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40062, 108),
      ))
    }

@delegate:ResourceContentHash(-2_121_152_828)
internal val Res.string.exp_content_facciamo_il_punto_2: StringResource by lazy {
      StringResource("string:exp_content_facciamo_il_punto_2", "exp_content_facciamo_il_punto_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 43515, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43503, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44615, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 41871, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40247, 59),
      ))
    }

@delegate:ResourceContentHash(446_149_979)
internal val Res.string.exp_content_facciamo_il_punto_3: StringResource by lazy {
      StringResource("string:exp_content_facciamo_il_punto_3", "exp_content_facciamo_il_punto_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 43583, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43563, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44679, 115),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 41931, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40307, 103),
      ))
    }

@delegate:ResourceContentHash(1_471_225_718)
internal val Res.string.exp_content_facciamo_il_punto_4: StringResource by lazy {
      StringResource("string:exp_content_facciamo_il_punto_4", "exp_content_facciamo_il_punto_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 43691, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43671, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44795, 135),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 42043, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40411, 123),
      ))
    }

@delegate:ResourceContentHash(-551_438_946)
internal val Res.string.exp_content_facciamo_il_punto_5: StringResource by lazy {
      StringResource("string:exp_content_facciamo_il_punto_5", "exp_content_facciamo_il_punto_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 43823, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43803, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44931, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 42167, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40535, 43),
      ))
    }

@delegate:ResourceContentHash(778_047_709)
internal val Res.string.exp_content_facciamo_il_punto_6: StringResource by lazy {
      StringResource("string:exp_content_facciamo_il_punto_6", "exp_content_facciamo_il_punto_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 43867, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43847, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44975, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 42211, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40579, 51),
      ))
    }

@delegate:ResourceContentHash(-1_345_869_447)
internal val Res.string.exp_content_facciamo_il_punto_7: StringResource by lazy {
      StringResource("string:exp_content_facciamo_il_punto_7", "exp_content_facciamo_il_punto_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 43915, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43903, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45023, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 42259, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40631, 107),
      ))
    }

@delegate:ResourceContentHash(219_471_535)
internal val Res.string.exp_content_facciamo_il_punto_8: StringResource by lazy {
      StringResource("string:exp_content_facciamo_il_punto_8", "exp_content_facciamo_il_punto_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 44043, 139),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44015, 147),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45151, 147),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 42375, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40739, 139),
      ))
    }

@delegate:ResourceContentHash(173_052_593)
internal val Res.string.exp_content_facciamo_il_punto_9: StringResource by lazy {
      StringResource("string:exp_content_facciamo_il_punto_9", "exp_content_facciamo_il_punto_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 44183, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44163, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45299, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 42519, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40879, 47),
      ))
    }

@delegate:ResourceContentHash(-1_303_046_918)
internal val Res.string.exp_content_facciamo_una_pausa_dalla_grammatica_e_torniamo_ai_cartigli:
    StringResource by lazy {
      StringResource("string:exp_content_facciamo_una_pausa_dalla_grammatica_e_torniamo_ai_cartigli", "exp_content_facciamo_una_pausa_dalla_grammatica_e_torniamo_ai_cartigli", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 44235, 182),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44215, 166),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45351, 166),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 42567, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40927, 158),
      ))
    }

@delegate:ResourceContentHash(-268_180_813)
internal val Res.string.exp_content_fai_attenzione_a_genere_e_numero_mi_raccomand: StringResource by
    lazy {
      StringResource("string:exp_content_fai_attenzione_a_genere_e_numero_mi_raccomand", "exp_content_fai_attenzione_a_genere_e_numero_mi_raccomand", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 44418, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44382, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45518, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 42726, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41086, 125),
      ))
    }

@delegate:ResourceContentHash(2_040_491_202)
internal val Res.string.exp_content_fai_attenzione_anche_all_ordine_di_lettura: StringResource by
    lazy {
      StringResource("string:exp_content_fai_attenzione_anche_all_ordine_di_lettura", "exp_content_fai_attenzione_anche_all_ordine_di_lettura", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 44532, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44520, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45656, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 42856, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41212, 118),
      ))
    }

@delegate:ResourceContentHash(-27_485_056)
internal val Res.string.exp_content_famiglia_societa_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_famiglia_societa_alyn_1", "exp_content_famiglia_societa_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 44643, 135),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44647, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45779, 135),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 42979, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41331, 131),
      ))
    }

@delegate:ResourceContentHash(938_699_159)
internal val Res.string.exp_content_famiglia_societa_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_famiglia_societa_nilo_1", "exp_content_famiglia_societa_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 44779, 179),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44771, 167),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45915, 179),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 43095, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41463, 163),
      ))
    }

@delegate:ResourceContentHash(1_804_962_727)
internal val Res.string.exp_content_fin_ora_abbiamo_visto_tre_significati_diversi_per_dei:
    StringResource by lazy {
      StringResource("string:exp_content_fin_ora_abbiamo_visto_tre_significati_diversi_per_dei", "exp_content_fin_ora_abbiamo_visto_tre_significati_diversi_per_dei", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 44959, 201),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44939, 185),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46095, 201),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 43255, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41627, 173),
      ))
    }

@delegate:ResourceContentHash(516_858_844)
internal val Res.string.exp_content_fine_della_spiegazione: StringResource by lazy {
      StringResource("string:exp_content_fine_della_spiegazione", "exp_content_fine_della_spiegazione", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 45161, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45125, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46297, 74),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 43429, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41801, 70),
      ))
    }

@delegate:ResourceContentHash(1_380_381_694)
internal val Res.string.exp_content_formare_verbi_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_formare_verbi_alyn_1", "exp_content_formare_verbi_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 45232, 136),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45208, 140),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46372, 132),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 43504, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41872, 124),
      ))
    }

@delegate:ResourceContentHash(1_034_411_971)
internal val Res.string.exp_content_formare_verbi_alyn_2: StringResource by lazy {
      StringResource("string:exp_content_formare_verbi_alyn_2", "exp_content_formare_verbi_alyn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 45369, 208),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45349, 184),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46505, 188),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 43637, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41997, 176),
      ))
    }

@delegate:ResourceContentHash(1_812_709_076)
internal val Res.string.exp_content_formare_verbi_alyn_3: StringResource by lazy {
      StringResource("string:exp_content_formare_verbi_alyn_3", "exp_content_formare_verbi_alyn_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 45578, 152),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45534, 144),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46694, 160),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 43806, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42174, 144),
      ))
    }

@delegate:ResourceContentHash(775_793_507)
internal val Res.string.exp_content_formare_verbi_alyn_4: StringResource by lazy {
      StringResource("string:exp_content_formare_verbi_alyn_4", "exp_content_formare_verbi_alyn_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 45731, 220),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45679, 212),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46855, 204),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 43951, 208),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42319, 188),
      ))
    }

@delegate:ResourceContentHash(-906_329_531)
internal val Res.string.exp_content_formare_verbi_alyn_5: StringResource by lazy {
      StringResource("string:exp_content_formare_verbi_alyn_5", "exp_content_formare_verbi_alyn_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 45952, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45892, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47060, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 44160, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42508, 60),
      ))
    }

@delegate:ResourceContentHash(1_364_343_437)
internal val Res.string.exp_content_formare_verbi_es1: StringResource by lazy {
      StringResource("string:exp_content_formare_verbi_es1", "exp_content_formare_verbi_es1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 46025, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45953, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47121, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 44221, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42569, 61),
      ))
    }

@delegate:ResourceContentHash(888_213_893)
internal val Res.string.exp_content_formare_verbi_es2: StringResource by lazy {
      StringResource("string:exp_content_formare_verbi_es2", "exp_content_formare_verbi_es2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 46087, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46015, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47183, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 44283, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42631, 57),
      ))
    }

@delegate:ResourceContentHash(1_743_251_201)
internal val Res.string.exp_content_formare_verbi_es3: StringResource by lazy {
      StringResource("string:exp_content_formare_verbi_es3", "exp_content_formare_verbi_es3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 46149, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46085, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47249, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 44345, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42689, 61),
      ))
    }

@delegate:ResourceContentHash(165_983_825)
internal val Res.string.exp_content_formare_verbi_es4: StringResource by lazy {
      StringResource("string:exp_content_formare_verbi_es4", "exp_content_formare_verbi_es4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 46211, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46147, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47311, 129),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 44407, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42751, 113),
      ))
    }

@delegate:ResourceContentHash(735_418_590)
internal val Res.string.exp_content_formare_verbi_nilo_comment: StringResource by lazy {
      StringResource("string:exp_content_formare_verbi_nilo_comment", "exp_content_formare_verbi_nilo_comment", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 46450, 154),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46382, 162),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47554, 170),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 44638, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42978, 154),
      ))
    }

@delegate:ResourceContentHash(-814_151_621)
internal val Res.string.exp_content_formare_verbi_nilo_comment_2: StringResource by lazy {
      StringResource("string:exp_content_formare_verbi_nilo_comment_2", "exp_content_formare_verbi_nilo_comment_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 46329, 120),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46269, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47441, 112),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 44525, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42865, 112),
      ))
    }

@delegate:ResourceContentHash(2_094_758_577)
internal val Res.string.exp_content_formare_verbi_zeta_1: StringResource by lazy {
      StringResource("string:exp_content_formare_verbi_zeta_1", "exp_content_formare_verbi_zeta_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 46605, 156),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46545, 148),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47725, 160),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 44785, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43133, 140),
      ))
    }

@delegate:ResourceContentHash(-1_010_399_030)
internal val Res.string.exp_content_formare_verbi_zeta_2: StringResource by lazy {
      StringResource("string:exp_content_formare_verbi_zeta_2", "exp_content_formare_verbi_zeta_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 46762, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46694, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47886, 104),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 44930, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43274, 92),
      ))
    }

@delegate:ResourceContentHash(244_851_186)
internal val Res.string.exp_content_formare_verbi_zeta_3: StringResource by lazy {
      StringResource("string:exp_content_formare_verbi_zeta_3", "exp_content_formare_verbi_zeta_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 46863, 128),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46791, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47991, 132),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 45027, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43367, 116),
      ))
    }

@delegate:ResourceContentHash(1_299_727_532)
internal val Res.string.exp_content_formare_verbi_zeta_4: StringResource by lazy {
      StringResource("string:exp_content_formare_verbi_zeta_4", "exp_content_formare_verbi_zeta_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 46992, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46912, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48124, 68),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 45148, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43484, 64),
      ))
    }

@delegate:ResourceContentHash(-1_748_847_909)
internal val Res.string.exp_content_fortunatamente_esiste_anche_il_genitivo_indiretto:
    StringResource by lazy {
      StringResource("string:exp_content_fortunatamente_esiste_anche_il_genitivo_indiretto", "exp_content_fortunatamente_esiste_anche_il_genitivo_indiretto", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 47057, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46985, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48193, 141),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 45213, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43549, 129),
      ))
    }

@delegate:ResourceContentHash(-282_594_898)
internal val Res.string.exp_content_frasi_avverbiali_1: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_1", "exp_content_frasi_avverbiali_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 48163, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48175, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49371, 146),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 46399, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44671, 134),
      ))
    }

@delegate:ResourceContentHash(-2_111_926_458)
internal val Res.string.exp_content_frasi_avverbiali_10: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_10", "exp_content_frasi_avverbiali_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 47191, 159),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47131, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48335, 139),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 45351, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43679, 135),
      ))
    }

@delegate:ResourceContentHash(1_340_286_328)
internal val Res.string.exp_content_frasi_avverbiali_11: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_11", "exp_content_frasi_avverbiali_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 47351, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47263, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48475, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 45515, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43815, 91),
      ))
    }

@delegate:ResourceContentHash(1_735_303_869)
internal val Res.string.exp_content_frasi_avverbiali_12: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_12", "exp_content_frasi_avverbiali_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 47443, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47363, 147),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48579, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 45607, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43907, 127),
      ))
    }

@delegate:ResourceContentHash(1_601_637_733)
internal val Res.string.exp_content_frasi_avverbiali_13: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_13", "exp_content_frasi_avverbiali_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 47571, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47511, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48707, 95),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 45747, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44035, 103),
      ))
    }

@delegate:ResourceContentHash(-1_312_581_650)
internal val Res.string.exp_content_frasi_avverbiali_14: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_14", "exp_content_frasi_avverbiali_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 47675, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47615, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48803, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 45851, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44139, 87),
      ))
    }

@delegate:ResourceContentHash(-726_000_332)
internal val Res.string.exp_content_frasi_avverbiali_15: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_15", "exp_content_frasi_avverbiali_15", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 47751, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47703, 147),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48891, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 45931, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44227, 135),
      ))
    }

@delegate:ResourceContentHash(1_905_569_289)
internal val Res.string.exp_content_frasi_avverbiali_16: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_16", "exp_content_frasi_avverbiali_16", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 47883, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47851, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49035, 131),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 46075, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44363, 115),
      ))
    }

@delegate:ResourceContentHash(-1_040_818_264)
internal val Res.string.exp_content_frasi_avverbiali_17: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_17", "exp_content_frasi_avverbiali_17", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 47995, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47979, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49167, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 46203, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44479, 111),
      ))
    }

@delegate:ResourceContentHash(-1_738_701_449)
internal val Res.string.exp_content_frasi_avverbiali_18: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_18", "exp_content_frasi_avverbiali_18", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 48087, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48083, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49291, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 46311, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44591, 79),
      ))
    }

@delegate:ResourceContentHash(-1_750_226_142)
internal val Res.string.exp_content_frasi_avverbiali_2: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_2", "exp_content_frasi_avverbiali_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 48290, 94),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48314, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49518, 114),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 46546, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44806, 98),
      ))
    }

@delegate:ResourceContentHash(2_128_452_913)
internal val Res.string.exp_content_frasi_avverbiali_3: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_3", "exp_content_frasi_avverbiali_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 48385, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48417, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49633, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 46653, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44905, 110),
      ))
    }

@delegate:ResourceContentHash(2_012_795_291)
internal val Res.string.exp_content_frasi_avverbiali_4: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_4", "exp_content_frasi_avverbiali_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 48492, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48536, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49756, 114),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 46772, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45016, 114),
      ))
    }

@delegate:ResourceContentHash(1_964_001_287)
internal val Res.string.exp_content_frasi_avverbiali_5: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_5", "exp_content_frasi_avverbiali_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 48599, 90),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48643, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49871, 86),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 46879, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45131, 86),
      ))
    }

@delegate:ResourceContentHash(539_708_023)
internal val Res.string.exp_content_frasi_avverbiali_6: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_6", "exp_content_frasi_avverbiali_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 48690, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48726, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49958, 86),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 46962, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45218, 86),
      ))
    }

@delegate:ResourceContentHash(-1_773_203_596)
internal val Res.string.exp_content_frasi_avverbiali_7: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_7", "exp_content_frasi_avverbiali_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 48777, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48809, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 50045, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 47045, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45305, 74),
      ))
    }

@delegate:ResourceContentHash(450_517_981)
internal val Res.string.exp_content_frasi_avverbiali_8: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_8", "exp_content_frasi_avverbiali_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 48852, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48896, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 50128, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 47124, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45380, 110),
      ))
    }

@delegate:ResourceContentHash(-262_645_943)
internal val Res.string.exp_content_frasi_avverbiali_9: StringResource by lazy {
      StringResource("string:exp_content_frasi_avverbiali_9", "exp_content_frasi_avverbiali_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 48963, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49031, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 50251, 54),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 47243, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45491, 50),
      ))
    }

@delegate:ResourceContentHash(1_447_542_843)
internal val Res.string.exp_content_frasi_con_pronomi_1: StringResource by lazy {
      StringResource("string:exp_content_frasi_con_pronomi_1", "exp_content_frasi_con_pronomi_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 49010, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49082, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 50306, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 47294, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45542, 111),
      ))
    }

@delegate:ResourceContentHash(-1_718_328_831)
internal val Res.string.exp_content_frasi_con_pronomi_2: StringResource by lazy {
      StringResource("string:exp_content_frasi_con_pronomi_2", "exp_content_frasi_con_pronomi_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 49134, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49210, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 50434, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 47406, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45654, 47),
      ))
    }

@delegate:ResourceContentHash(-1_736_615_639)
internal val Res.string.exp_content_frasi_con_pronomi_3: StringResource by lazy {
      StringResource("string:exp_content_frasi_con_pronomi_3", "exp_content_frasi_con_pronomi_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 49182, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49262, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 50486, 115),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 47454, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45702, 107),
      ))
    }

@delegate:ResourceContentHash(1_042_905_141)
internal val Res.string.exp_content_frasi_con_pronomi_4: StringResource by lazy {
      StringResource("string:exp_content_frasi_con_pronomi_4", "exp_content_frasi_con_pronomi_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 49298, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49370, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 50602, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 47558, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45810, 47),
      ))
    }

@delegate:ResourceContentHash(-1_085_070_773)
internal val Res.string.exp_content_frasi_con_pronomi_5: StringResource by lazy {
      StringResource("string:exp_content_frasi_con_pronomi_5", "exp_content_frasi_con_pronomi_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 49346, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49426, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 50654, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 47606, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45858, 87),
      ))
    }

@delegate:ResourceContentHash(489_688_870)
internal val Res.string.exp_content_frasi_con_pronomi_6: StringResource by lazy {
      StringResource("string:exp_content_frasi_con_pronomi_6", "exp_content_frasi_con_pronomi_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 49434, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49510, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 50754, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 47690, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45946, 67),
      ))
    }

@delegate:ResourceContentHash(767_803_589)
internal val Res.string.exp_content_frasi_con_pronomi_7: StringResource by lazy {
      StringResource("string:exp_content_frasi_con_pronomi_7", "exp_content_frasi_con_pronomi_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 49506, 151),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49582, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 50826, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 47762, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46014, 139),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString4Resources(map: MutableMap<String, StringResource>) {
  map.put("exp_content_e_guarda_la_seconda_parola_racchiusa_nel_cart", Res.string.exp_content_e_guarda_la_seconda_parola_racchiusa_nel_cart)
  map.put("exp_content_e_poi_all_interno_uhm_imn_twt_ankh", Res.string.exp_content_e_poi_all_interno_uhm_imn_twt_ankh)
  map.put("exp_content_ecco_fatto_1", Res.string.exp_content_ecco_fatto_1)
  map.put("exp_content_ecco_fatto_2", Res.string.exp_content_ecco_fatto_2)
  map.put("exp_content_ecco_fatto_3", Res.string.exp_content_ecco_fatto_3)
  map.put("exp_content_ecco_fatto_4", Res.string.exp_content_ecco_fatto_4)
  map.put("exp_content_ecco_fatto_5", Res.string.exp_content_ecco_fatto_5)
  map.put("exp_content_ecco_fatto_6", Res.string.exp_content_ecco_fatto_6)
  map.put("exp_content_ecco_fatto_7", Res.string.exp_content_ecco_fatto_7)
  map.put("exp_content_ecco_fatto_8", Res.string.exp_content_ecco_fatto_8)
  map.put("exp_content_ecco_un_elenco_di_tre_elementi_n_falco_pesce_", Res.string.exp_content_ecco_un_elenco_di_tre_elementi_n_falco_pesce_)
  map.put("exp_content_ecco_un_secondo_giro_di_simboli", Res.string.exp_content_ecco_un_secondo_giro_di_simboli)
  map.put("exp_content_ecco_vari_modi_di_scrivere_le_due_sorelle_snt", Res.string.exp_content_ecco_vari_modi_di_scrivere_le_due_sorelle_snt)
  map.put("exp_content_eccoci_al_tempio_di_bastet", Res.string.exp_content_eccoci_al_tempio_di_bastet)
  map.put("exp_content_empty", Res.string.exp_content_empty)
  map.put("exp_content_end_verb_1_alyn_1", Res.string.exp_content_end_verb_1_alyn_1)
  map.put("exp_content_end_verb_1_alyn_2", Res.string.exp_content_end_verb_1_alyn_2)
  map.put("exp_content_end_verb_1_alyn_3", Res.string.exp_content_end_verb_1_alyn_3)
  map.put("exp_content_end_verb_1_nilo_1", Res.string.exp_content_end_verb_1_nilo_1)
  map.put("exp_content_end_verb_1_zeta_1", Res.string.exp_content_end_verb_1_zeta_1)
  map.put("exp_content_end_verb_1_zeta_2", Res.string.exp_content_end_verb_1_zeta_2)
  map.put("exp_content_end_verb_1_zeta_3", Res.string.exp_content_end_verb_1_zeta_3)
  map.put("exp_content_end_verb_1_zeta_4", Res.string.exp_content_end_verb_1_zeta_4)
  map.put("exp_content_end_verb_1_zeta_5", Res.string.exp_content_end_verb_1_zeta_5)
  map.put("exp_content_ending_vso_alyn_1", Res.string.exp_content_ending_vso_alyn_1)
  map.put("exp_content_ending_vso_alyn_2", Res.string.exp_content_ending_vso_alyn_2)
  map.put("exp_content_ending_vso_alyn_3", Res.string.exp_content_ending_vso_alyn_3)
  map.put("exp_content_ending_vso_masko_1", Res.string.exp_content_ending_vso_masko_1)
  map.put("exp_content_ending_vso_masko_2", Res.string.exp_content_ending_vso_masko_2)
  map.put("exp_content_ending_vso_masko_3", Res.string.exp_content_ending_vso_masko_3)
  map.put("exp_content_ending_vso_masko_4", Res.string.exp_content_ending_vso_masko_4)
  map.put("exp_content_ending_vso_nilo_1", Res.string.exp_content_ending_vso_nilo_1)
  map.put("exp_content_esempi", Res.string.exp_content_esempi)
  map.put("exp_content_esempio_genitivo_indiretto_femminile_plurale", Res.string.exp_content_esempio_genitivo_indiretto_femminile_plurale)
  map.put("exp_content_esempio_genitivo_indiretto_femminile_singolare", Res.string.exp_content_esempio_genitivo_indiretto_femminile_singolare)
  map.put("exp_content_esempio_genitivo_indiretto_maschile_plurale", Res.string.exp_content_esempio_genitivo_indiretto_maschile_plurale)
  map.put("exp_content_esempio_genitivo_indiretto_maschile_singolare", Res.string.exp_content_esempio_genitivo_indiretto_maschile_singolare)
  map.put("exp_content_esempio_padre_any_n_nil_padre_any_n_s_n_un", Res.string.exp_content_esempio_padre_any_n_nil_padre_any_n_s_n_un)
  map.put("exp_content_esempio_sacerdote_ptah_n_nil_sacerdote_ptah_n", Res.string.exp_content_esempio_sacerdote_ptah_n_nil_sacerdote_ptah_n)
  map.put("exp_content_esiste_poi_anche_il_plurale_duale_che_si_fa_a", Res.string.exp_content_esiste_poi_anche_il_plurale_duale_che_si_fa_a)
  map.put("exp_content_esistono_diversi_tipi_di_segni_n_n_fonogrammi", Res.string.exp_content_esistono_diversi_tipi_di_segni_n_n_fonogrammi)
  map.put("exp_content_esploriamo_l_ambiente_e_il_mondo_egizio", Res.string.exp_content_esploriamo_l_ambiente_e_il_mondo_egizio)
  map.put("exp_content_facciamo_il_punto_1", Res.string.exp_content_facciamo_il_punto_1)
  map.put("exp_content_facciamo_il_punto_10", Res.string.exp_content_facciamo_il_punto_10)
  map.put("exp_content_facciamo_il_punto_2", Res.string.exp_content_facciamo_il_punto_2)
  map.put("exp_content_facciamo_il_punto_3", Res.string.exp_content_facciamo_il_punto_3)
  map.put("exp_content_facciamo_il_punto_4", Res.string.exp_content_facciamo_il_punto_4)
  map.put("exp_content_facciamo_il_punto_5", Res.string.exp_content_facciamo_il_punto_5)
  map.put("exp_content_facciamo_il_punto_6", Res.string.exp_content_facciamo_il_punto_6)
  map.put("exp_content_facciamo_il_punto_7", Res.string.exp_content_facciamo_il_punto_7)
  map.put("exp_content_facciamo_il_punto_8", Res.string.exp_content_facciamo_il_punto_8)
  map.put("exp_content_facciamo_il_punto_9", Res.string.exp_content_facciamo_il_punto_9)
  map.put("exp_content_facciamo_una_pausa_dalla_grammatica_e_torniamo_ai_cartigli", Res.string.exp_content_facciamo_una_pausa_dalla_grammatica_e_torniamo_ai_cartigli)
  map.put("exp_content_fai_attenzione_a_genere_e_numero_mi_raccomand", Res.string.exp_content_fai_attenzione_a_genere_e_numero_mi_raccomand)
  map.put("exp_content_fai_attenzione_anche_all_ordine_di_lettura", Res.string.exp_content_fai_attenzione_anche_all_ordine_di_lettura)
  map.put("exp_content_famiglia_societa_alyn_1", Res.string.exp_content_famiglia_societa_alyn_1)
  map.put("exp_content_famiglia_societa_nilo_1", Res.string.exp_content_famiglia_societa_nilo_1)
  map.put("exp_content_fin_ora_abbiamo_visto_tre_significati_diversi_per_dei", Res.string.exp_content_fin_ora_abbiamo_visto_tre_significati_diversi_per_dei)
  map.put("exp_content_fine_della_spiegazione", Res.string.exp_content_fine_della_spiegazione)
  map.put("exp_content_formare_verbi_alyn_1", Res.string.exp_content_formare_verbi_alyn_1)
  map.put("exp_content_formare_verbi_alyn_2", Res.string.exp_content_formare_verbi_alyn_2)
  map.put("exp_content_formare_verbi_alyn_3", Res.string.exp_content_formare_verbi_alyn_3)
  map.put("exp_content_formare_verbi_alyn_4", Res.string.exp_content_formare_verbi_alyn_4)
  map.put("exp_content_formare_verbi_alyn_5", Res.string.exp_content_formare_verbi_alyn_5)
  map.put("exp_content_formare_verbi_es1", Res.string.exp_content_formare_verbi_es1)
  map.put("exp_content_formare_verbi_es2", Res.string.exp_content_formare_verbi_es2)
  map.put("exp_content_formare_verbi_es3", Res.string.exp_content_formare_verbi_es3)
  map.put("exp_content_formare_verbi_es4", Res.string.exp_content_formare_verbi_es4)
  map.put("exp_content_formare_verbi_nilo_comment", Res.string.exp_content_formare_verbi_nilo_comment)
  map.put("exp_content_formare_verbi_nilo_comment_2", Res.string.exp_content_formare_verbi_nilo_comment_2)
  map.put("exp_content_formare_verbi_zeta_1", Res.string.exp_content_formare_verbi_zeta_1)
  map.put("exp_content_formare_verbi_zeta_2", Res.string.exp_content_formare_verbi_zeta_2)
  map.put("exp_content_formare_verbi_zeta_3", Res.string.exp_content_formare_verbi_zeta_3)
  map.put("exp_content_formare_verbi_zeta_4", Res.string.exp_content_formare_verbi_zeta_4)
  map.put("exp_content_fortunatamente_esiste_anche_il_genitivo_indiretto", Res.string.exp_content_fortunatamente_esiste_anche_il_genitivo_indiretto)
  map.put("exp_content_frasi_avverbiali_1", Res.string.exp_content_frasi_avverbiali_1)
  map.put("exp_content_frasi_avverbiali_10", Res.string.exp_content_frasi_avverbiali_10)
  map.put("exp_content_frasi_avverbiali_11", Res.string.exp_content_frasi_avverbiali_11)
  map.put("exp_content_frasi_avverbiali_12", Res.string.exp_content_frasi_avverbiali_12)
  map.put("exp_content_frasi_avverbiali_13", Res.string.exp_content_frasi_avverbiali_13)
  map.put("exp_content_frasi_avverbiali_14", Res.string.exp_content_frasi_avverbiali_14)
  map.put("exp_content_frasi_avverbiali_15", Res.string.exp_content_frasi_avverbiali_15)
  map.put("exp_content_frasi_avverbiali_16", Res.string.exp_content_frasi_avverbiali_16)
  map.put("exp_content_frasi_avverbiali_17", Res.string.exp_content_frasi_avverbiali_17)
  map.put("exp_content_frasi_avverbiali_18", Res.string.exp_content_frasi_avverbiali_18)
  map.put("exp_content_frasi_avverbiali_2", Res.string.exp_content_frasi_avverbiali_2)
  map.put("exp_content_frasi_avverbiali_3", Res.string.exp_content_frasi_avverbiali_3)
  map.put("exp_content_frasi_avverbiali_4", Res.string.exp_content_frasi_avverbiali_4)
  map.put("exp_content_frasi_avverbiali_5", Res.string.exp_content_frasi_avverbiali_5)
  map.put("exp_content_frasi_avverbiali_6", Res.string.exp_content_frasi_avverbiali_6)
  map.put("exp_content_frasi_avverbiali_7", Res.string.exp_content_frasi_avverbiali_7)
  map.put("exp_content_frasi_avverbiali_8", Res.string.exp_content_frasi_avverbiali_8)
  map.put("exp_content_frasi_avverbiali_9", Res.string.exp_content_frasi_avverbiali_9)
  map.put("exp_content_frasi_con_pronomi_1", Res.string.exp_content_frasi_con_pronomi_1)
  map.put("exp_content_frasi_con_pronomi_2", Res.string.exp_content_frasi_con_pronomi_2)
  map.put("exp_content_frasi_con_pronomi_3", Res.string.exp_content_frasi_con_pronomi_3)
  map.put("exp_content_frasi_con_pronomi_4", Res.string.exp_content_frasi_con_pronomi_4)
  map.put("exp_content_frasi_con_pronomi_5", Res.string.exp_content_frasi_con_pronomi_5)
  map.put("exp_content_frasi_con_pronomi_6", Res.string.exp_content_frasi_con_pronomi_6)
  map.put("exp_content_frasi_con_pronomi_7", Res.string.exp_content_frasi_con_pronomi_7)
}
